export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            folderPaths: [{
                id: "",
                name: "资料库",
                parentId: ""
            }],
            folderList: [],
            fileList: [],
            mySelectFileList: [],
            searchContent: ""
        }
    },
    props: {
        show: {
            type: Boolean,
            value: false
        },
        selectedFileInfo: {
            type: Object,
            value: null
        },
        singleChoose: {
            type: Boolean,
            value: false
        },
        selectedFileList: {
            type: Array,
            value: []
        }
    },
    watch: {
        show(newVal, oldVal) {//监控单个变量
            if (newVal)
                this.refresh();
        }
    },
    methods: {
        /**
         * 刷新
         */
        refresh: function () {
            this.folderPaths = [{
                id: "",
                name: "资料库",
                parentId: ""
            }];
            this.folderList = [];
            this.fileList = [];
            this.searchContent = "";
            if (this.singleChoose)
                this.mySelectFileList = this.selectedFileInfo==null?[]:[Object.assign({}, this.selectedFileInfo)];
            else
                this.mySelectFileList = Object.assign([], this.selectedFileList);
            this.query();
        },
        /**
         * 文件选择事件
         * @param {*} e 
         */
        onFileCheck: function (item) {
            if(this.singleChoose && item.checked && this.mySelectFileList.length==1){
                this.$message.closeAll();
                this.$message.warning("只能选择一个文件");
                item.checked = false;
                return;
            }
            if (item.checked) {
                this.mySelectFileList.push(item);
            } else {
                for (var i = 0; i < this.mySelectFileList.length; i++) {
                    if (this.mySelectFileList[i].id == item.id) {
                        this.mySelectFileList.splice(i, 1);
                        break;
                    }
                }
            }
        },

        /**
         * 移除已选择文件
         * @param {*} item 
         */
        removeSelectFile: function (item) {
            for (var i = 0; i < this.mySelectFileList.length; i++) {
                if (this.mySelectFileList[i].id == item.id) {
                    var file = this.mySelectFileList[i];
                    this.mySelectFileList.splice(i, 1);
                    for (var i = 0; i < this.fileList.length; i++) {
                        if (this.fileList[i].id == file.id) {
                            this.fileList[i].checked = false;
                            return;
                        }
                    }
                    return;
                }
            }
        },

        /**
         * 关闭弹框
         */
        handleClose: function () {
            this.$emit("onClose", false);
        },

        /**
         * 点击确定
         */
        confirm: function () {
            if(this.mySelectFileList == null || this.mySelectFileList.length==0){
                this.$message.closeAll();
                this.$message.warning("至少勾选一个文件");
                return;
            }
            this.$emit("onConfirm", this.mySelectFileList);
        },

        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "esc": //点击返回
                    if (this.folderPaths.length == 1) {
                        this.$message.closeAll();
                        this.$message.warning("已经是首页了");
                        return;
                    }
                    this.folderPaths.pop();
                    this.query();
                    break;
                case "refresh": //刷新
                    this.query();
                    break;
                case "folderPath"://点击面包屑路径
                    if (data.id == this.folderPaths[this.folderPaths.length - 1].id) return;
                    for (var i = 0; i < this.folderPaths.length; i++) {
                        if (this.folderPaths[i].id == data.id) {
                            this.folderPaths.splice(i + 1);
                            break;
                        }
                    }
                    this.query();
                    break;
                default:
                    break;
            }
        },

        /**
         * 双击事件
         * @param {*} id 
         * @param {*} data 
         */
        dbClickEvent: function (id, data) {
            switch (id) {
                case "folder": //文件夹
                    this.folderPaths.push(data);
                    this.query();
                    break;
                case "file": //文件
                    if (data.fileType == 1 || data.fileType == 2 || data.fileType == 3 || data.fileType == 4)
                        window.open(this.baseUrl + data.path, "_blank");
                    break;
            }
        },

        /**
         * 格式化日期
         * @param {*} date 
         */
        formatDate: function (date) {
            if (date == null)
                return "-";
            if (date.length <= 10)
                return date.substring(0, date.length);
            return date.substring(0, 10);
        },

        /**
         * 获取文件类型图标
         * @param {*} item 
         */
        getFileIconType: function (item) {
            switch (item.fileType) {
                case 2: //视频
                    return require("../../../static/images/ic_file_video.png");
                case 3: //音频
                    return require("../../../static/images/ic_file_audio.png");
                case 4: //office
                    var suffix = item.suffix.toLowerCase();
                    if (suffix == "doc" || suffix == "docx")
                        return require("../../../static/images/ic_file_word.png");
                    else if (suffix == "xlsx" || suffix == "xls")
                        return require("../../../static/images/ic_file_excel.png");
                    else if (suffix == "ppt" || suffix == "pptx")
                        return require("../../../static/images/ic_file_ppt.png");
                    else if (suffix == "txt")
                        return require("../../../static/images/ic_file_txt.png");
                    else if (suffix == "pdf")
                        return require("../../../static/images/ic_file_pdf.png");
                    else
                        return require("../../../static/images/ic_file_default.png");
                default:
                    return require("../../../static/images/ic_file_default.png");
            }
        },

        /**
         * 输入变化
         * @param {*} e 
         */
        onSearchChange: function (val) {
            this.query();
        },

        /**
         * 查询全部文件夹
         */
        query: function () {
            //查文件夹列表
            this.$post({
                url: 'folder/query',
                params: {
                    parentId: this.folderPaths[this.folderPaths.length - 1].id,
                    keyWord: this.searchContent
                }
            }, true).then(data => {
                data.forEach(elem => {
                    elem.checked = false;
                });
                this.folderList = data;
            });
            //查文件列表
            this.$post({
                url: 'file/findByFolderFile',
                params: {
                    folderId: this.folderPaths[this.folderPaths.length - 1].id,
                    keyWord: this.searchContent
                }
            }, true).then(data => {
                data.forEach(elem => {
                    elem.checked = false;
                });
                for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < this.mySelectFileList.length; j++) {
                        if (data[i].id == this.mySelectFileList[j].id) {
                            data[i].checked = true;
                            break
                        }
                    }
                }
                this.fileList = data;
            });
        }
    }
}